<template>
    <div class="service-details ptb-100">
        <div class="container">
            <div class="service-details-content">
                <h3 data-aos="fade-up" data-aos-once="true">Nach dem Launch ist vor dem Erfolg</h3>

                <p data-aos="fade-up" data-aos-delay="100" data-aos-once="true">Eine Webseite ist kein Projekt, das man einmal erstellt und dann vergisst. Sie braucht regelmäßige Pflege, Sicherheitsupdates und technische Wartung. Wir bieten Ihnen langfristige Betreuung, damit Sie sich auf Ihr Kerngeschäft konzentrieren können.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-delay="0" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-revision'></i>
                            </div>
                            <h3>Regelmäßige Updates</h3>
                            <p>Frameworks, Dependencies, Sicherheitspatches - alles bleibt aktuell und sicher. Kontrollierte Updates ohne Überraschungen.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-delay="100" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-shield'></i>
                            </div>
                            <h3>Sicherheitsüberwachung</h3>
                            <p>Proaktive Sicherheitschecks und schnelle Reaktion bei Problemen. Ihre Webseite bleibt geschützt.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-delay="200" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-cloud-download'></i>
                            </div>
                            <h3>Backup-Service</h3>
                            <p>Tägliche automatische Backups. Bei Problemen kann ich Ihre Seite schnell wiederherstellen.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-delay="300" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-support'></i>
                            </div>
                            <h3>Technischer Support</h3>
                            <p>Schnelle Hilfe bei Fragen oder Problemen. Per E-Mail oder Telefon - ich bin für Sie da.</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Warum Betreuung so wichtig ist</h4>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-once="true">Ohne regelmäßige Wartung passiert das:</p>

                <ul class="features-list mb-4" data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
                    <li><i class='bx bx-x text-danger'></i> <strong>Sicherheitslücken</strong> - Veraltete Software ist ein Einfallstor für Hacker</li>
                    <li><i class='bx bx-x text-danger'></i> <strong>Funktionsstörungen</strong> - Inkompatible Updates können die Seite lahmlegen</li>
                    <li><i class='bx bx-x text-danger'></i> <strong>Datenverlust</strong> - Ohne Backups kann ein Serverausfall fatal sein</li>
                    <li><i class='bx bx-x text-danger'></i> <strong>Google-Abwertung</strong> - Langsame oder unsichere Seiten werden schlechter gerankt</li>
                </ul>

                <p data-aos="fade-up" data-aos-once="true">Mit einem Betreuungspaket sind Sie auf der sicheren Seite:</p>

                <ul class="features-list" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">
                    <li><i class='bx bx-check'></i> <strong>Monatliche Wartung</strong> - Alle Updates werden zeitnah eingespielt</li>
                    <li><i class='bx bx-check'></i> <strong>Performance-Monitoring</strong> - Ladezeiten werden überwacht und optimiert</li>
                    <li><i class='bx bx-check'></i> <strong>Uptime-Überwachung</strong> - Bei Ausfällen werde ich sofort benachrichtigt</li>
                    <li><i class='bx bx-check'></i> <strong>Kleine Änderungen inklusive</strong> - Textanpassungen, neue Bilder, kleine Korrekturen</li>
                    <li><i class='bx bx-check'></i> <strong>Bevorzugter Support</strong> - Ihre Anfragen werden prioritär behandelt</li>
                </ul>

                <h4 data-aos="fade-up" data-aos-once="true">Flexibel nach Ihrem Bedarf</h4>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-once="true">Nicht jede Webseite braucht das gleiche Maß an Betreuung. Eine einfache Landingpage benötigt weniger Aufmerksamkeit als ein aktiver Online-Shop. Wir erstellen ein Paket, das zu Ihrer Webseite und Ihrem Budget passt - keine überdimensionierten Verträge, keine unnötigen Kosten.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-4 col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay="0" data-aos-once="true">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-time'></i>
                            <h3>24h</h3>
                            <p>Reaktionszeit bei kritischen Problemen</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay="100" data-aos-once="true">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-calendar'></i>
                            <h3>Monatlich</h3>
                            <p>Kündbar - keine langfristigen Bindungen</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6" data-aos="zoom-in" data-aos-delay="200" data-aos-once="true">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-check-shield'></i>
                            <h3>100%</h3>
                            <p>Transparenz bei allen Arbeiten</p>
                        </div>
                    </div>
                </div>

                <div class="pricing-box mt-5" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
                    <div class="single-pricing-table">
                        <div class="pricing-header">
                            <h3>Sorglos-Paket</h3>
                        </div>

                        <div class="price">
                            <span class="price-text">Nach Vereinbarung</span>
                        </div>

                        <p class="pricing-description">Lassen Sie uns besprechen, welche Betreuung Ihre Webseite braucht.</p>

                        <ul class="pricing-features">
                            <li><i class='bx bxs-badge-check'></i> Regelmäßige Updates & Wartung</li>
                            <li><i class='bx bxs-badge-check'></i> Sicherheits-Monitoring</li>
                            <li><i class='bx bxs-badge-check'></i> Performance-Optimierung</li>
                            <li><i class='bx bxs-badge-check'></i> Backups & Wiederherstellung</li>
                            <li><i class='bx bxs-badge-check'></i> Technischer Support</li>
                            <li><i class='bx bxs-badge-check'></i> Monatliche Reports</li>
                        </ul>

                        <div class="btn-box">
                            <router-link to="/contact" class="default-btn">
                                <i class='bx bxs-paper-plane'></i>
                                Beratungsgespräch vereinbaren
                                <span></span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BetreuungDetails'
}
</script>

<style scoped>
.pricing-box {
    max-width: 450px;
    margin: 0 auto;
}

.pricing-box .single-pricing-table {
    background: #ffffff;
    border-radius: 10px;
    padding: 40px 30px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.pricing-box .pricing-header h3 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #080a3c;
}

.pricing-box .price {
    margin-bottom: 25px;
}

.pricing-box .price-text {
    font-size: 28px;
    font-weight: 700;
    color: #010215;
}

.pricing-box .pricing-description {
    color: #4a6f8a;
    margin-bottom: 25px;
    font-size: 15px;
}

.pricing-box .pricing-features {
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;
    text-align: left;
}

.pricing-box .pricing-features li {
    padding: 12px 0 !important;
    padding-left: 0 !important;
    border-bottom: 1px solid #eee;
    color: #4a6f8a;
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 12px;
    position: static !important;
}

.pricing-box .pricing-features li:last-child {
    border-bottom: none;
}

.pricing-box .pricing-features li i {
    color: #010215;
    font-size: 18px;
    flex-shrink: 0;
    position: static !important;
}

.pricing-box .btn-box {
    text-align: center;
}
</style>
